export default __webpack_public_path__ + "static/itIndustry-b8f8b27a8577fc3ea5c06412eff817b1.png";